import React, { Component } from 'react'
import Layouts from './components/Layouts'
import {
  Input,
  Radio,
  Form,
  Col,
  Button,
  message,
  Table,
  Select,
  Tabs,
  Row,
  Tooltip,
  Popconfirm,
} from 'antd'
import { EditOutlined, DeleteOutlined } from '@ant-design/icons'
import apiRequest from './hooks/ApiRequest'

const { Option } = Select

class RiskItem extends Component {
  constructor() {
    super()
    this.state = {
      stampDuty: 0,
      smtpPort: '',
      smtpPassword: '',
      currency: '',
      reinsuranceLimit: 0,
      reinsuranceLimitMail: '',
      smtpDisplayName: '',
      smtpHost: '',
      smtpMail: '',
      allData: '',
      riskItemList: [],
      riskCoverDrop: [],
      productDrop: [], //john 18 May 2022
      newRiskCover: '',
      productId: '',
      coverId: '', //john 18 May 2022
      coverName: '', //john 18 May 2022
      data: [],
      coverType: '',
      productName: '',
      riskItemName: '',
      ratePercentage: '',
      riskItemId: 0,
      columns: [
        { key: '1', title: 'Product Name', dataIndex: 'productname' },
        { key: '2', title: 'Cover Name', dataIndex: 'riskname' },
        { key: '3', title: 'Item Name', dataIndex: 'riskitemname' },
        {
          key: '4',
          title: 'Cover Type',
          dataIndex: 'covertype',
          render: covertype => covertype || '-',
        },
        {
          key: '5',
          title: 'Rate(%) / Agreed Value',
          dataIndex: 'ratepercentage',
          render: (value, record) => {
            if (record.covertype === 'Agreed Value') {
              // show $ format
              const num = parseFloat(value || 0).toFixed(2);
              return `$ ${num}`;
            } else {
              // show % format
              const num = parseFloat(value || 0).toFixed(2);
              return `${num}%`;
            }
          },
        },
        {
          key: '6',
          title: 'Action',
          render: (_, record) => (
            <>
              <Tooltip title="Edit">
                <Button
                  type="primary"
                  className="edit_btn"
                  onClick={() =>
                    this.handleEditRiskItem(
                      record.productname,
                      record.riskname,
                      record.riskitemname,
                      record.covertype,
                      record.ratepercentage,
                      record.riskitemid,
                      record.productid,
                      record.coverid
                    )
                  }>
                  <EditOutlined />
                </Button>
              </Tooltip>
              <Popconfirm
                className="delete_btn"
                title="Are you sure you want to delete this record ?"
                onConfirm={() => this.handleDeleteRiskItem(record.riskitemid)}>
                <Tooltip title="Delete">
                  <Button type="danger" style={{ marginLeft: 8 }}>
                    <DeleteOutlined />
                  </Button>
                </Tooltip>
              </Popconfirm>
            </>
          ),
        },
      ],

    }
    this.productChange = this.productChange.bind(this)
    this.coverTypeChange = this.coverTypeChange.bind(this)
    this.coverChange = this.coverChange.bind(this)
  }

  handleDeleteRiskItem = async (riskitemid) => {

    try {
      const res = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_ADMIN}/Product/DeleteRiskItemById/risk-item/${riskitemid}`,
        'POST'
      );

      if (res.success) {
        message.success('Risk Item Deleted Successfully !!').then(() => {
          window.location.reload(false);
        });
      } else {
        message.error('Failed to delete risk item.');
      }
    } catch (error) {
      console.error("Request failed:", error);
      message.error('An error occurred while deleting.');
    }
  }

  handleEditRiskItem = async (
    productname,
    riskname,
    riskitemname,
    covertype,
    rate,
    riskitemid,
    productid,
    coverid
  ) => {
    this.setState({
      coverType: covertype,
      productName: productname,
      riskItemName: riskitemname,
      ratePercentage: rate.toString(),
      riskItemId: riskitemid,
      productId: productid,
      coverName: riskname,
      coverId: coverid,
    });

    // Call the fetch function
    await this.fetchRiskCoverById(productid);
  };

  fetchRiskCoverById = async (productid) => {
    try {
      const response = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_ADMIN}/Product/GetRiskCoverbyId/${productid}`,
        'GET'
      );

      if (response.success) {
        this.setState({ riskCoverDrop: response.data.result });
      } else {
        console.error("API Error:", response.error);
      }
    } catch (error) {
      console.error("Request failed:", error);
    }
  };


  componentDidMount = async () => {
    const response = await apiRequest(process.env.REACT_APP_BASE_URL_ADMIN + '/Product/GetRiskItembyId/risk-item/0', 'GET');
    if (response.success) {
      this.setState({ data: response.data.result })
    }
    const res = await apiRequest(process.env.REACT_APP_BASE_URL_ADMIN + '/Product/GetAllProducts', 'GET');
    console.log('pro', res);

    if (res.success) {
      console.log('hloo');

      this.setState({ productDrop: res.data.data })

    }
  }

  updateRisktem = async (e) => {
    e.preventDefault()

    this.props.form.validateFields(async (err, values) => {
      const isUpdate = this.state.riskItemId !== 0;
      if (!err) {
        var res = {
          riskitemid: this.state.riskItemId,
          riskitemname: values.riskItemName,
          productid: this.state.productId,
          ratepercentage: parseFloat(values.ratePercentage).toFixed(2),
          createdby: parseInt(localStorage.getItem('loggedInUserID')),
          modifiedby: parseInt(localStorage.getItem('loggedInUserID')),
          createddate: new Date(),
          modifieddate: new Date(),
          isactive: true,
          covertype: this.state.coverType,
          coverid: this.state.coverId,
          coverName: this.state.coverName,
        }
        if (this.state.riskItemId !== '') {
          res.riskitemid = this.state.riskItemId
        }
        const url = isUpdate
          ? `${process.env.REACT_APP_BASE_URL_ADMIN}/Product/UpdateRiskItem/UpdateRiskItem`
          : `${process.env.REACT_APP_BASE_URL_ADMIN}/Product/AddRiskItem/AddRiskItem`;
        const response = await apiRequest(url, 'POST', res);

        if (response.success) {
          if (response.data.status == true) {
            message.success('Risk Item Updated Successfully !!')
            window.location.reload(false)
          }
          else {
            message.error(response.data.message)
          }

        }

      }
    })
  }

  productChange = async (value) => {
    this.setState({ productId: value });
    try {
      const response = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_ADMIN}/Product/GetRiskCoverbyId/0`,
        'GET'
      );

      if (response.success) {
        this.setState({ riskCoverDrop: response.data.result });
      } else {
        console.error("API Error:", response.error);
      }
    } catch (error) {
      console.error("Request failed:", error);
    }
  };

  coverTypeChange(value) {
    this.setState({ coverType: value })
  }
  coverChange(value) {
    this.setState({ coverId: value })
  }

  render() {
    const { getFieldDecorator } = this.props.form

    let riskCoverList =
      this.state.riskCoverDrop.length > 0 &&
      this.state.riskCoverDrop
        .filter(item => item.productid === this.state.productId)
        .map((item, i) => (
          <Select.Option key={i} value={item.riskcoverid}>
            {item.riskname}
          </Select.Option>
        ));
    let productList =
      this.state.productDrop.length > 0 &&
      this.state.productDrop.map((item, i) => {
        return (
          <Select.Option key={i} value={item.productid}>
            {item.productname}
          </Select.Option>
        )
      }, this)
    // console.log(this.state.riskCoverDrop);
    // console.log("Selected Product:", this.state.productId);
    // console.log(riskCoverList);

    return (
      <div title="assets" className="ant-layout-content dashboard">
        <div className="dash-bg-white">
          <Row gutter={[16, 16]}>
            <Col xs={12} sm={24} md={24} lg={12}>
              <div className="section-top-heading">
                <h3
                  style={{
                    color: '#0C1362',
                    fontWeight: '600',
                    fontSize: '20px',
                  }}>
                  {' '}
                  Manage Risk Items
                </h3>
              </div>
            </Col>
          </Row>
        </div>
        <div className="dash-bg-white">
          <Form onSubmit={this.updateRisktem}>
            <Row gutter={[16, 16]}>
              {this.state.productName === '' && (
                <Col xs={24} md={12} lg={4}>
                  <labe>Product:</labe>
                  <Select
                    placeholder="Select Product"
                    onChange={this.productChange}
                    style={{ display: 'inline' }}>
                    {productList}
                  </Select>
                </Col>
              )}
              {this.state.productName !== '' && (
                <Col xs={24} md={12} lg={4}>
                  <labe>Product:</labe>
                  <Select
                    value={this.state.productName}
                    placeholder="Select Product"
                    onChange={this.productChange}
                    style={{ display: 'inline' }}>
                    {productList}
                  </Select>
                </Col>
              )}
              {this.state.coverName === '' && (
                <Col xs={24} md={12} lg={4}>
                  <labe>Policy Cover:</labe>
                  <Select
                    placeholder="Select Cover"
                    onChange={this.coverChange}
                    style={{ display: 'inline' }}>
                    {riskCoverList}
                  </Select>
                </Col>
              )}
              {this.state.coverName !== '' && (
                <Col xs={24} md={12} lg={4}>
                  <labe>Policy Cover:</labe>
                  <Select
                    value={this.state.coverName}
                    placeholder="Select Cover"
                    onChange={this.coverChange}
                    style={{ display: 'inline' }}>
                    {riskCoverList}
                  </Select>
                </Col>
              )}

              <Col xs={24} md={12} lg={4}>
                {this.state.riskItemName === '' && (
                  <Form.Item label="New Risk Item">
                    {getFieldDecorator('riskItemName', {
                      rules: [
                        {
                          required: true,
                          message: 'Please input Risk Item!',
                          whitespace: false,
                        },
                      ],
                    })(<Input placeholder="Risk Item" />)}
                  </Form.Item>
                )}
                {this.state.riskItemName !== '' && (
                  <Form.Item label="New Risk Item">
                    {getFieldDecorator('riskItemName', {
                      rules: [
                        {
                          required: true,
                          message: 'Please input Risk Item!',
                          whitespace: false,
                        },
                      ],
                      initialValue: this.state.riskItemName,
                    })(<Input placeholder="Risk Item" />)}
                  </Form.Item>
                )}
              </Col>
              <Col xs={24} md={12} lg={4}>
                <Form.Item
                  label={
                    this.state.coverType === 'Agreed Value'
                      ? 'Agreed Value ($)'
                      : 'Rate (%)'
                  }>
                  {getFieldDecorator('ratePercentage', {
                    rules: [
                      {
                        required: true,
                        message:
                          this.state.coverType === 'Agreed Value'
                            ? 'Please input Agreed Value!'
                            : 'Please input Rate Percentage!',
                        whitespace: false,
                      },
                    ],
                    initialValue: this.state.ratePercentage || '',
                  })(
                    <Input
                      placeholder={this.state.coverType === 'Agreed Value' ? '0.00' : '0.00%'}
                      prefix={this.state.coverType === 'Agreed Value' ? '$' : null}
                      suffix={this.state.coverType === 'Agreed Value' ? null : '%'}
                      type="number"
                      onChange={(e) =>
                        this.setState({ ratePercentage: e.target.value })
                      }
                    />
                  )}
                </Form.Item>
              </Col>

              <Col xs={24} md={12} lg={4}>
                <Form.Item label="Cover Type">
                  {this.state.coverType === '' && (
                    <Select
                      defaultValue="--Select option--"
                      onChange={this.coverTypeChange}
                      style={{ display: 'inline' }}>
                      <Option value="Sum Insured">Sum Insured</Option>
                      <Option value="Agreed Value">Agreed Value</Option>
                    </Select>
                  )}
                  {this.state.coverType !== '' && (
                    <Select
                      value={this.state.coverType}
                      defaultValue="--Select option--"
                      onChange={this.coverTypeChange}
                      style={{ display: 'inline' }}>
                      <Option value="Sum Insured">Sum Insured</Option>
                      <Option value="Agreed Value">Agreed Value</Option>
                    </Select>
                  )}
                </Form.Item>
              </Col>
              <Col xs={24} md={12} lg={4}>
                <Button htmlType="submit" className="primary m-t-22">
                  Add
                </Button>
              </Col>
            </Row>
          </Form>
        </div>
        <div className="table-grid-bx">
          <Table
            className="table-scroll-auto"
            columns={this.state.columns}
            dataSource={this.state.data}
            pagination={false}
          />
        </div>
      </div>
    )
  }
}

const WrappedRiskItem = Form.create({ name: 'Homeinsurance_list' })(RiskItem)

export default WrappedRiskItem
